import { Box, Typography, Checkbox } from "@mui/material";
import { FS } from "@plannel/utils/font-util";

/*
 * 차트 하단 시리즈 범례(체크박스로 on/off).
 *
 * 두 가지 모드를 모두 지원한다 — 이전엔 같은 마크업이 카드마다 복제돼 있었다:
 *   1) 영속 모드  : 체크 상태가 z_p13n chartConfig.activeFlg (판매현황 카드)
 *   2) 임시 모드  : 체크 상태가 컴포넌트 로컬 state (제품군 카드의 hidden)
 * 어느 쪽이든 isActive/onToggle 만 다르게 주입하면 된다.
 *
 * items: [{ key, label, color }]
 */
const SeriesLegend = ({ items = [], isActive, onToggle, gap = 1.5 }) => (
  <Box sx={{ display: "flex", justifyContent: "center", gap, mt: 0.5, flexWrap: "wrap" }}>
    {items.map((l) => (
      <Box key={l.key} sx={{ display: "flex", alignItems: "center", gap: 0.3 }}>
        <Checkbox
          checked={isActive(l.key)}
          onChange={() => onToggle(l.key)}
          size="small"
          sx={{ p: 0.3, color: l.color, "&.Mui-checked": { color: l.color } }}
        />
        <Typography sx={{ fontSize: FS.BODY, color: "text.primary" }}>{l.label}</Typography>
      </Box>
    ))}
  </Box>
);

export default SeriesLegend;
